angular.module('iqxCore')
  .controller('ApplicationCtrl', function (initSessionSvc, $scope, menuSvc, ApplicationSvc, loginSvc, FormSvc, $location, $window, SweetAlert, newVersionSvc, pinSvc) {
    // initSessionSvc (initSession.svc.js) Handles all the Login/Session Restore logic

    $scope.theme = 'theme'
    $scope.showWelcomeMessage = false
    $scope.params = ApplicationSvc.params
    $scope.isApp = ApplicationSvc.isApp
    $scope.params.toggleMenu = false
    $scope.params.subMenuActive = []
    $scope.orientation = {}
    $scope.checkPermissions = ApplicationSvc.checkPermissions
    $scope.newVersionAvailable = false
    $scope.isWebView = ApplicationSvc.isWebView
    $scope.usingpinauth = ApplicationSvc.currentUser.pinauth // so we know globaly
    $scope.lock = pinSvc.lock
    $scope.menu = menuSvc.menu
    $scope.usingAuth0 = localStorage.getItem('usingAuth0')

    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function makesafe(str) {
      str = str.replace(/\\'/g, '\'')
      str = str.replace(/\\"/g, '"')
      str = str.replace(/\\0/g, '\0')
      str = str.replace(/\\\\/g, '\\')
      var str = str.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';'
      })
      return str
    }

    $scope.setTheme = function () {
      if (getParameterByName('theme') == "clear") {
        localStorage.customTheme = undefined
        localStorage.keepstyle = undefined
        delete localStorage.customTheme
        delete localStorage.keepstyle
        return true
      }

      if (getParameterByName('theme') && getParameterByName('theme') != '' && getParameterByName('theme').indexOf("http") === -1) {
        var theme = getParameterByName('theme')
        $scope.params.customLogoFile = makesafe(theme) + ".png"
        if (getParameterByName('changestyle') == 'true') {
          $scope.theme = makesafe(theme)
          localStorage.keepstyle = 'false'
        }
        localStorage.customTheme = makesafe(theme)
        return true
      }

      if (localStorage.customTheme && localStorage.customTheme.indexOf("http") === -1) {
        var theme = makesafe(localStorage.customTheme)
        $scope.params.customLogoFile = makesafe(localStorage.customTheme) + ".png"

        if (localStorage.keepstyle == 'false') {
          $scope.theme = makesafe(localStorage.customTheme)
        }

        return true
      }
    }

    $scope.doQuickSearch = function (searchType, searchValue) {
      if (!searchValue) {
        alert("You need a search term.")
      } else {
        window.location.href = "/search/all/" + searchValue
        $scope.params.toggleMenu = false
      }
    }

    //accessibility resize function, pass in "+", "-", "reset" or nothing (to take current setting stored in localstorage if there are any)
    $scope.accessibilityResize = function (newSize) {
      var documentBody = document.querySelector("body")
      var currentZoom = 1
      var newZoom = 1
      if (localStorage.currentZoom) {
        currentZoom = localStorage.currentZoom
      } else {
        currentZoom = 1
      }
      if (newSize == "+") {
        newZoom = Number(currentZoom) + Number(0.05)
      } else if (newSize == "-") {
        newZoom = Number(currentZoom) - Number(0.05)
      } else if (newSize == "reset") {
        newZoom = 1
      } else {
        newZoom = currentZoom
      }
      if (newZoom >= 1.3) {
        newZoom = 1.3
        $scope.disableResizeButton = "+"
      } else if (newZoom <= 0.8) {
        newZoom = 0.8
        $scope.disableResizeButton = "-"
      } else {
        $scope.disableResizeButton = ""
      }
      documentBody.style.zoom = newZoom
      localStorage.currentZoom = newZoom
    }

    //check to see if page should resize on load
    $scope.accessibilityResize()
    $scope.highContrastEnabled = false

    $scope.toggleHighContrast = function () {
      if (!$scope.highContrastEnabled) {
        $scope.highContrastEnabled = true
        localStorage.highContrastEnabled = 1
      } else {
        $scope.highContrastEnabled = false
        localStorage.highContrastEnabled = 0
      }
    }

    $scope.checkHightContrastSettings = function () {
      if (localStorage.highContrastEnabled == 1) {
        $scope.highContrastEnabled = true
      } else {
        $scope.highContrastEnabled = false
      }
    }

    $scope.checkHightContrastSettings()

    $scope.isMenuItemActive = function (path) {
      var activePage = angular.element(document.querySelector(".sidebar-menu>li.active"))
      if (activePage.text()) {
        $scope.browserPageTitle = $scope.params.BROWSERTITLE + " - " + activePage.text() || $scope.params.BROWSERTITLE
      } else {
        $scope.browserPageTitle = $scope.params.BROWSERTITLE
      }

      path = path.replace("/", "/")
      return $location.path().substr(0, path.length) === path
    }

    $scope.toggleMenu = function (direction) {
      switch (direction) {
        case 'open':
          $scope.params.toggleMenu = true
          break

        case 'close':
          $scope.params.toggleMenu = false
          break
      }
    }

    $scope.passwordOpts = function () {
      if ($scope.params.PASSWORD_MIN == 0 || !$scope.params.PASSWORD_MIN) {
        var passwordminenabled = false
        var passwordminChar = 0
      } else {
        var passwordminenabled = true
        var passwordminChar = $scope.params.PASSWORD_MIN
      }

      return $scope.passwordOptions = {
        'toggle': true,
        'keepHeight': false,
        'minimum': passwordminenabled,
        'minlength': passwordminChar,
        'lowercase': true,
        'uppercase': ($scope.params.PASSWORD_CAPITAL === undefined ? true : $scope.params.PASSWORD_CAPITAL),
        'number': ($scope.params.PASSWORD_DIGIT === undefined ? true : $scope.params.PASSWORD_DIGIT),
        'special': ($scope.params.PASSWORD_PUNCTUATION === undefined ? true : $scope.params.PASSWORD_PUNCTUATION)
      }
    }

    function logThemOut() {
      loginSvc.setLoggedOut()
      $scope.$evalAsync(function () {
        if ($scope.isApp !== true) {
          $location.url('/login')
        } else {
          window.location.href = "/login"
        }
      })
    }

    $scope.logout = function () {
      if (ApplicationSvc.currentUser.pinauth === true && window.location.href.indexOf('/pin') === -1) {
        var logouttime = moment().add(30, 'seconds')
        var countdown = setInterval(function () {
          var secondsLeft = logouttime.diff(moment(), 'seconds')
          if (secondsLeft <= 0) {
            clearInterval(countdown)
            logThemOut()
          } else {
            document.getElementById("countdown").innerHTML = secondsLeft
          }
        }, 1000);

        SweetAlert.swal({
          title: "Are you sure?",
          html: "You currently have a PIN setup, logging out will remove the PIN and you will need to set this up again when you next login.  <br /><br />You will be logged out after <span id='countdown'>30</span> second(s).<br /><br />Continue with logout, or alternatively lock your session and retain your PIN?",
          type: "warning",
          confirmButtonText: "Logout",
          cancelButtonText: "Lock Session",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(function (result) {
          if (result.dismiss) {
            clearInterval(countdown)
            $scope.lock()
          } else {
            clearInterval(countdown)
            loginSvc.setLoggedOut()
            $scope.$evalAsync(function () {
              if ($scope.isApp !== true) {
                $location.url('/login')
              } else {
                window.location.href = "/login"
              }
            })
          }
        })
      } else {
        loginSvc.setLoggedOut()
        $scope.$evalAsync(function () {
          if ($scope.isApp !== true) {
            $location.url('/login')
          } else {
            window.location.href = "/login"
          }
        })
      }
    }
    $scope.changePassword = function () {
      $location.url('/changepassword')
    }
    $scope.createPIN = function () {
      $location.url('/settings?createPIN=true')
    }
    $scope.DontShowOnRegisterPage = function () {
      return ApplicationSvc.onRegisterPage
    }
    $scope.isLoggedIn = function () {
      return ApplicationSvc.isLoggedIn
    }
    $scope.appMode = function () {
      return ApplicationSvc.appMode
    }
    $scope.userName = function () {
      return ApplicationSvc.currentUser.UserName
    }
    $scope.accountMarkedFordeletion = function(){
      return ApplicationSvc.currentUser.markedForDeletion
    }
    $scope.userClass = function () {
      return ApplicationSvc.currentUser.UserClass
    }
    $scope.userHasRight = function (right) {
      return (ApplicationSvc.currentUser.UserRights && ApplicationSvc.currentUser.UserRights.indexOf(right) >= 0)
    }
    $scope.isSwitchedOn = ApplicationSvc.isSwitchedOn
    $scope.stopProp = function ($event) {
      $event.stopPropagation()
    }
    $scope.iAppleFix = function () {
      var head = document.getElementsByTagName('head')[0]
      var s = document.createElement('style')
      s.setAttribute('type', 'text/css')
      if (s.styleSheet) { // IE
        s.styleSheet.cssText = '.modal-body .form-group {max-width: 100%;}'
      } else { // the world
        s.appendChild(document.createTextNode('.modal-body .form-group {max-width: 100%;}'))
      }
      head.appendChild(s)
    }

    if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
      $scope.iAppleFix()
    }

    $scope.checkIfMobile = function () {
      var check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
      if (check == false) {
        // don't think it is mobile view, but check screen width, and return true if it is tiny (<768)
        if (window.innerWidth <= 767) {
          check = true
        }
      }
      return check;
    }

    $scope.isMobile = $scope.checkIfMobile()

    window.onresize = function () {
      $scope.isMobile = $scope.checkIfMobile()
      $scope.$apply()
    }

    $scope.getWindowOrientation = function () {
      return $window.orientation
    }

    if ($scope.checkIfMobile) {
      $scope.$watch($scope.getWindowOrientation, function (newValue, oldValue) {
        $scope.phoneOrientation = newValue
      }, true)

      angular.element($window).bind('orientationchange', function () {
        $scope.$apply()
      })
    }

    $scope.setTheme()

    $scope.newVersionRefresh = function () {
      newVersionSvc.prompt()
    }

    $scope.newVersionAvailable = function () {
      return newVersionSvc.available
    }

  })
